import React, {Component} from 'react';

import axios from 'axios';
import auth0Client from '../Auth';
import {withRouter} from 'react-router-dom';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import LostItemFunctions from '../LostItem/LostItemFunctions';
import {SERVER_URL}  from '../Constants';
import ReactImageMagnify from 'react-image-magnify';

const { SearchBar } = Search;


const columns = [
  { dataField: 'id', text: 'Picture', headerStyle: {width:'80px'},
        
        formatter: imageFormat 
    },
    { dataField: 'itemNumber', text: '#',sort: true, hidden:false, headerStyle: {width:'80px'}},

  { dataField: 'shortDescription',classes:'text-primary',  text: 'Item', filterable:true, sort: true, textAlign: 'left' },

   { dataField: 'foundDate', text: 'Found',classes:'text-primary', formatter: LostItemFunctions.formatDate, sort: true },
   { dataField: 'longDescription', text: 'Desc',classes:'text-primary', filterable:true, sort: true, textAlign: 'left', style:{fontSize:11} },
   { dataField: 'locationName', text: 'Found Near',classes:'text-primary',filterable:true, sort: true, textAlign: 'left', style:{fontSize:11} },

  { dataField: 'keywords', text: 'keywords',sort: true, hidden:true},
 

];
// { 
    //dataField: 'itemState',classes:LostItemFunctions.statusColFormater, sort: true,formatter: LostItemFunctions.itemStatusDesc, text: 'Status',  textAlign: 'left'
 // },

function imageFormat(cell, row){
    if (row.url){
        return (
            <img src={row.url} width={50} alt={row.shortDescription} />
        )
    }
}





class LostItemPicker extends Component {


  


  constructor(props) {
    super(props);

    this.state = {
      questions: null,
      showCards: false,
      lostItems:[],
      filteredItems:[],
      filteredStatus:'',
      displayLargeImageModal:false,
      selectedImageUrl:''
    };

    this.rowEvents = {
      onClick: (e, row, rowIndex) => {
        if (e.target.tagName.toLowerCase() === 'img'){
            //console.log(this + ' ' + `clicked on row with index: ${rowIndex}`);
            e.stopPropagation(); //dont check
            this.setState({
              selectedImageUrl : e.target.src,
              displayLargeImageModal:true});
              return;
        }


        this.props.assignLostItemId(row.id);
       
    
      },
      
    };

    
    

  }





  async componentDidMount() {

    let height = 200;
  this.setState({tableHeight: height + "px"});

    /*const lostItems = (await axios.get(SERVER_URL +'/LostItems',{
        headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,
         'venueId' : auth0Client.getActiveVenuedId() }
      })).data;
    this.setState({
        lostItems: lostItems,
        filteredItems : lostItems
    });*/
    this.loadOpenItems();

  }

  loadOpenItems=async()=>{
        const lostItems = (await axios.post(SERVER_URL +'/LostItems/Query',{
          queryParams:{itemState:'Q'}
          },{
          headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,
          'venueId' : auth0Client.getActiveVenuedId() }
        })).data;
      this.setState({
          lostItems: lostItems,
          filteredItems : lostItems
      });
    }

  


  renderGrid=()=>{
    return (

      <div >
       
       
   

        <ToolkitProvider 
          bootstrap4
          keyField='id' 
          data={ this.state.filteredItems } 
          columns={ columns } 
          search
        
          >
          {
    props => (
      <div>
       
        <SearchBar { ...props.searchProps } />
        <hr />
        <BootstrapTable
        
          striped
          hover
          condensed
          rowEvents={this.rowEvents}
         
          { ...props.baseProps }
          pagination={ paginationFactory() }
         
          maxHeight={500}
        />
      </div>
    )
  }</ToolkitProvider>

      </div>


    )

    
  }

  gridClick=()=>
  {
    this.setState( {showCards:false })
  }

  cardClick=()=>
  {
    this.setState( {showCards:true })
  }

  gridSort=(col)=>{


  }

 filterButtonClick=(event)=>{

    // Select case

    
    const target = event.target;
    console.log(target.id);

    var filter = 'A';
    switch(target.id){
      case 'optArchive': filter = 'A'; break;
      case 'opClaimed':filter = 'C'; break;
      case 'optPublished':filter = 'P'; break;
      case 'optQueued':filter = 'Q'; break;
      default: filter = 'Q';


    }
    

    var filteredItems = this.state.lostItems.filter((lostItem) =>{
        if (lostItem.itemState === filter){
          return lostItem;
        }else{ return null;}
    });

    this.setState({
      filteredItems: filteredItems
    });

    return true;
 }


 renderLargeImage=()=>{

  return(
    
 
     // <Modal style={{ position:'relative', zIndex:'100'}}   open={this.state.displayLargeImageModal} onClose={()=>this.setState({displayLargeImageModal:false})} center>
     <div style={{zIndex:'100', position:'relative', display: (this.state.displayLargeImageModal) ? 'block' : 'none'}}>  
     <ReactImageMagnify  style={{width:700, height:600, position:'relative'}} enlargedImagePosition='over' {...{
                                    smallImage: {
                                        alt: this.state.shortDescription,
                                        isFluidWidth: false,
                                        src: this.state.selectedImageUrl,
                                        width:700,
                                        height:600
                                    },
                                    largeImage: {
                                        src: this.state.selectedImageUrl,
                                        width: 1800,
                                        height: 1600
                                    },
                                    isHintEnabled: true,
                                    shouldHideHintAfterFirstActivation: false
                                }} />
        
          <button title="Close"    className="btn btn-info" onClick={()=>{this.setState({displayLargeImageModal:false})}}>Close </button>

      </div>
      )
}

  render() {
     return(
     <div className="p-3">

        <h4>LOST ITEMS</h4>
        <p className="text-info">Select row to assign the lost item to the claim</p>
        
            {this.renderGrid() }
          
            {this.renderLargeImage()}
         
         
        
        </div>

     )
  }
}

export default withRouter(LostItemPicker);